module.exports = __webpack_public_path__ + "img/thumbnail_PlainsZebra_m_normal.bc710248.png";